import React, { useState, useEffect, Fragment,useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, Container, Modal, Form, Row, Col, Button, Spinner } from 'react-bootstrap'
import {LoadingComponent} from 'recupero-comunes'
import { useFormik } from 'formik'
import {validationSchemasAtenderInformeProfesional} from '../../common/validation-Schemas-atender-informe-profesional';
import { isValidParam } from '../../common/Formatos'
import { serviceGestionarInforme} from '../../api/api-atender-informe-profesional';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../api/api-parametros';
import Mensajes from '../mensajes.js'
import {CarpetaDigitalComponent} from 'defcol-caso-general'

const AtenderInformeRAT = ({ showModal, setShowModal, idCaso, idOrgCaso, solicitud, handleReload, idTrxOrigen}) => {

    const {state}=useLocation()
    const fileRef = useRef();
    const [cfg_form, setCfg_form] = useState(null);
    const [loading, setLoading] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});

    const [comentarios, setComentarios] = React.useState('')
    const [fechaInforme, setFechaInforme] = React.useState('')
    const [fechaMin, setFechaMin]=useState('')

    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    useEffect(() => {
        if (showModal) {
            (async () => {
                const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
                setLimites({ liviano, pesado });
            })();
        }
    }, [showModal])

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    }

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    }

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        handleLimpiar();
        setShowModal(false);
        handleReload();
    }
    const handleLimpiar = () => {
        formik.resetForm();   
        setComentarios("");
        setFechaInforme("");
    }

    const handleClose = () => {
        setShowModal(false);
    }
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": "",
            "fechaInforme": "",
            "comentarios": "",
        },
        validationSchema: validationSchemasAtenderInformeProfesional(solicitud.codTipoInforme, limites.pesado),
        onSubmit: async (formData) => {

            let dataForm = {
                ...formData
            }
            dataForm['idCaso'] = idCaso;
            dataForm['idImplicadoCaso'] = 0;
            dataForm['idOrganizacion'] = idOrgCaso;
            dataForm['idSolicitud'] = solicitud.idSolicitud;
            dataForm['accion'] = 3;//Atender Informe RAT
            dataForm['idImplicado'] = solicitud.idImplicado;
            dataForm['tipoInforme'] = solicitud.codTipoInforme;
            dataForm['idTrxOrigen'] = idTrxOrigen;

            setLoading(true);

            try {
                let fileData = null;

                if (formData.file) {
                    if (esArchivoGrande(formData.file, limites.liviano)) {
                        let archivoRef;
                        if (archivoSubidoRef.current.file === formData.file) {
                            archivoRef = archivoSubidoRef.current;
                        } else {
                            archivoRef = await subirArchivoGrandeS3(formData.file);
                            archivoSubidoRef.current = { file: formData.file, ...archivoRef };
                        }
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, s3Bucket: archivoRef.s3Bucket, s3Key: archivoRef.s3Key };
                    } else {
                        const base64data = await getBase64(formData.file);
                        fileData = { filename: formData.file.name, mimetype: formData.file.type, base64data: base64data.split(',')[1] };
                    }
                }

                let data = { ...dataForm };
                if (fileData) data.file = fileData;

                const response = await serviceGestionarInforme(data);
                setRespuestaGestion(response);
                handleShowToast(true);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error(error.message);
                alert(error.message);
            }
        }
    })
    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta= () => setShowCarpeta(false) 
return (
    <div>
        <Fragment>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
                    idCaso={solicitud && solicitud.idCaso}
                    idImplicado={solicitud && solicitud.idImplicado}
                    idOrganizacionCaso={solicitud && solicitud.idOrgBien}
                    prototipo={2}            
                />    
            </Modal>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='xl'>
                <LoadingComponent show={loading}/>
                <Form onSubmit={formik.handleSubmit}>
                <Card >
                    <Card.Header className='cardHeader'>
                        {(cfg_form && cfg_form["atender-informerat-titleing"]) ? cfg_form["atender-informerat-titleing"] : 'Atender Informe RAT'}
                    </Card.Header>
                    <Card.Body>

                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-title-datsin"]) ? cfg_form["atender-informerat-title-datsin"] : 'Datos del Siniestro'}
                                </Form.Label>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-sin"]) ? cfg_form["atender-informerat-datsin-sin"] : 'Siniestro'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['siniestro']) ? solicitud['siniestro'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-placa"]) ? cfg_form["atender-informerat-datsin-placa"] : 'Placa'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['placa']) ? solicitud['placa'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-fechasig"]) ? cfg_form["atender-informerat-datsin-fechasig"] : 'Fecha Asignación'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['fecSolicitudFormat']) ? solicitud['fecSolicitudFormat'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-respsol"]) ? cfg_form["atender-informerat-datsin-respsol"] : 'Responsable CIA Solicita'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['responsableSolicita']) ? solicitud['responsableSolicita'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-comentario"]) ? cfg_form["atender-informerat-datsin-comentario"] : 'Comentario CIA'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['comentario']) ? solicitud['comentario'] : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='containerHeader'>
                            <Col md='4'>
                                <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-abogado"]) ? cfg_form["atender-informerat-datsin-abogado"] : 'Abogado del Caso'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['responsableAsignado']) ? solicitud['responsableAsignado'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='4'>
                                <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-datsin-fechaaud"]) ? cfg_form["atender-informerat-datsin-fechaaud"] : 'Fecha Audiencia Informe'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {solicitud && isValidParam(solicitud['FechaAudiencia']) ? solicitud['FechaAudiencia'] : ''}
                                </Form.Text>
                            </Col>
                            <Col md='4'></Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label style={{ fontWeight: 'bold', fontSize: '16px' }}>
                                    {(cfg_form && cfg_form["atender-informerat-title-datinf"]) ? cfg_form["atender-informerat-title-datinf"] : 'Datos del Informe'}
                                </Form.Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="5">
                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                    {(cfg_form && cfg_form['atender-informerat-datinf-input-comentarios']) ? cfg_form && cfg_form['atender-informerat-datinf-input-comentarios'] : 'Comentarios'}
                                </Form.Label>
                                {' '}
                                <br/>
                                <Form.Control as='textarea' className='mb-2'
                                    rows={2}
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setComentarios(e.target.value)
                                        }
                                    }
                                    name='comentarios'
                                    value={
                                        (formik.values.comentarios = comentarios)
                                    }
                                    error={
                                        formik.errors.comentarios
                                    }/>
                                    {formik.errors.comentarios ? (
                                        <Form.Text variant='danger' style={{ color: 'red' }}>
                                            {formik.errors.comentarios}
                                        </Form.Text>
                                        ) : (
                                        ''
                                    )}
                            </Col>
                            <Col md='2'>
                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informerat-datinf-input-fechainf']) ? cfg_form && cfg_form['atender-informerat-datinf-input-fechainf'] : 'Fecha Informe'} *
                                </Form.Label>
                                {' '}
                                <br/>
                                <Form.Control className='mb-0' type='date'
                                    value={
                                        (formik.values.fechaInforme = fechaInforme)
                                    }
                                    min={
                                        fechaMin && fechaMin
                                        
                                    }
                                    max={hoy()}
                                    name='fechaInforme'
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setFechaInforme(e.target.value)
                                        }
                                    }
                                    error={formik.errors.fechaInforme}
                                >                                                    
                                </Form.Control>
                                {formik.errors.fechaInforme ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.fechaInforme}
                                    </Form.Text>
                                    ) : (
                                    ''
                                )}                                        
                            </Col>
                            <Col md='5'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form['atender-informerat-datinf-input-subirdcto']) ? cfg_form && cfg_form['atender-informerat-datinf-input-subirdcto'] : 'Subir Informe'} *
                                </Form.Label>
                                <Form.Group className="position-relative mb-2 mt-1">
                                    <Form.Control ref={fileRef} type="file" name="file"
                                        onChange={handleFileChange} onBlur={formik.handleBlur}
                                        isInvalid={!!formik.errors.file}
                                        isValid={formik.touched.file && !formik.errors.file}
                                    />
                                    <Form.Text className="text-muted">{`Tamaño máximo del archivo: ${limites.pesado / 1000000}MB`}</Form.Text>
                                    <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                                </Form.Group>                                                
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        <Row className='containerHeader'>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                    {(cfg_form && cfg_form["atender-informerat-btncerrar"]) ? cfg_form["atender-informerat-btncerrar"] : 'Cerrar'}
                                </Button>
                                <Button style={{ width: '130px', marginRight: '5px' }} variant='carpeta' onClick={handleShowCarpeta}>
                                    {(cfg_form && cfg_form["atender-informerat-btncarpeta"]) ? cfg_form["atender-informerat-btncarpeta"] : 'Documentos'}
                                </Button>
                                <Button style={{ width: '135px', color: 'white' }} variant='solicitar' type='onSubmit' disabled={loading}>
                                    {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                    {(cfg_form && cfg_form["atender-informerat-btnsolicitar"]) ? cfg_form["atender-informerat-btnsolicitar"] : 'Registrar Informe'}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Container>
                    <Row>
                        <Col>
                            {respuestaGestion && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaGestion}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container>
                </Form>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Confirmación
                    </Card.Header>
                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>
                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .containerHeader {
                        display: flex;
                        justify-content: space-between;
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                        padding: 1rem;
                    }
                    .customHeaderCard {
                        background-color: #676999;
                        color: #fff;
                        font-size: 17px;
                        font-weight: 600;
                        text-align: center;
                        text-decoration: underline;
                    }
                    .cursor {
                        cursor: pointer;
                    }
                    .btn-carpeta {
                        background-color: #F0AD3E;
                        color: #FFFFFF;
                        width: 140px;                    
                    }
                    .btn-carpeta:hover{
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-solicitar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 140px;
                        padding:6px 0px 6px 0px;
                    }
                    .btn-solicitar:hover{
                        background-color:  #F6897E;
                        color: #FFFFFF;
                    }
                `}
            </style>         
        </Fragment>
    </div>
  )
}
export default AtenderInformeRAT
const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};